import { styled } from '@material-ui/core';

export const HeaderContent = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1),
  paddingLeft: theme.spacing(2),
  marginLeft: 'auto',
}));
